import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from './shared/services/app.service';
import { AuthService } from './shared/services/auth.service';
import { UserService } from './shared/services/users.service';
import { ProviderServiceService } from './shared/services/provider_service.service';
import { Roles } from './shared/models/roles';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'transferswap';
  init = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private appService: AppService,
    private userService: UserService,
    private providerServicesService: ProviderServiceService,
    private auth: AuthService,
  ) {}

  ngOnInit(): void {
    void this.bootstrapApp();
  }

  private async bootstrapApp(): Promise<void> {
    try {
      await this.appService.getConfig();
    } catch (error) {
      console.error('Error loading app config:', error);
      return;
    }

    if (this.isPayRoute()) {
      this.init = true;
      return;
    }

    try {
      const token = localStorage.getItem('transferswap_token');
      if (!token) {
        await this.router.navigate(['auth']);
        this.init = true;
        return;
      }

      const user = await this.authService.getUser();

      await this.providerServicesService.getProviderServices();

      if (!user) {
        await this.router.navigate(['auth']);
        this.init = true;
        return;
      }

      await this.authService.openForceChangePasswordFlow();

      await this.userService.setUserBalance();

      if (this.auth.canViewUsers()) {
        await this.userService.getUsers();
      }

      if (this.auth.hasRole(Roles.Admin)) {
        await this.userService.loadPlatformServices();
      } else {
        await this.userService.loadCurrentUserPlatformServices();
      }

      if (this.shouldRedirectToDashboardAfterLogin()) {
        await this.router.navigate(['dashboard']);
      }
      this.init = true;
    } catch (error) {
      console.error('Error during app bootstrap:', error);
      await this.router.navigate(['auth']);
      this.init = true;
    }
  }

  private isPayRoute(): boolean {
    const path =
      typeof window !== 'undefined'
        ? window.location.pathname
        : this.router.url;

    return path === '/pay' || path.startsWith('/pay/');
  }

  private shouldRedirectToDashboardAfterLogin(): boolean {
    const path =
      typeof window !== 'undefined'
        ? window.location.pathname
        : this.router.url;
    const normalized = (path || '').trim().toLowerCase();

    // Preserve deep links (e.g. /cashins?payin_id=...) instead of forcing dashboard.
    return (
      normalized === '' ||
      normalized === '/' ||
      normalized === '/auth' ||
      normalized.startsWith('/auth/')
    );
  }
}
